import { Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'cc-ng1-user-new-invite'
})
export class Ng1UserNewInviteDirective extends UpgradeComponent {
  @Input() users;
  @Input() stats;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('usersInviteNew', elementRef, injector);
  }
}
